import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const chromeTokenSchema = z.object({
  id: z.number(),
  token: z.string(),
  expiry_date: z.string(),
  used_on: z.string().nullable(),
  user: z.number(),
  created: z.string(),
  updated: z.string(),
});

export const chromeTokenApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "createChromeToken",
    method: "post",
    path: "/chrometoken/",
    status: 201,
    response: chromeTokenSchema,
  })
    .addEndpoint({
      alias: "getChromeToken",
      method: "get",
      path: "/chrometoken/:id/",
      parameters: [
        {
          name: "id",
          type: "Path",
          schema: z.number(),
        },
      ],
      status: 200,
      response: chromeTokenSchema,
    })
    .build(),
);
